import { useContext } from 'react';

/**
 * Retrieves the value from a React context or throws an error if the value is null.
 */
export function useContextOrThrow(context, message) {
  var value = useContext(context);
  if (value === null) {
    throw new Error(message || "Expected a value from context ".concat(context.displayName));
  }
  return value;
}